import { InputProps } from '@chakra-ui/input';
import theme from '@chakra-ui/theme';

export const Input = {
  parts: ['field', 'addon'],
  baseStyle: {
    field: {
      border: '1px solid',
      color: 'white',
      fontWeight: 'bold',
      caretColor: 'currentColor',
      boxShadow:
        '0px -1px 12px 0px rgba(0, 0, 0, 0.25) inset, 0px 2px 5px 0px rgba(0, 0, 0, 0.40)',

      borderRightRadius: 'md',
      borderColor: 'beta.500',
      bg: 'beta.800',

      '&&': {
        borderLeft: 'none',
      },

      '&::placeholder': {
        color: 'whiteAlpha.500',
      },

      '&:focus, &:active, &:hover': {
        '&&': {
          bg: 'beta.600',
          borderColor: 'beta.400',
        },
      },

      '&:-webkit-autofill': {
        caretColor: 'currentColor',
        '&:hover, &:focus, &:active': { caretColor: 'currentColor' },
      },
    },
    addon: {
      fontWeight: 'black',
      fontSize: 'sm',
      color: 'white',
      '&&': {
        bg: 'beta.500',
        borderLeftRadius: 'lg',
        border: 'none',
      },
    },
  },
  sizes: {
    lg: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
    md: { addon: { borderRadius: 'sm' }, field: { borderRadius: 'sm' } },
  },
  variants: {
    unstyled: (props: InputProps) => {
      const { addon, field } = theme.components.Input.variants.outline(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        props as any
      );

      return {
        addon,
        field: {
          ...field,
          '&&': {
            boxShadow: 'none',
            color: 'black',
            bg: 'white',
            borderRadius: 'base',
            h: '40px',
            borderColor: 'white',
            pl: '2.5',
          },
          '&:focus, &:active, &:hover': {
            '&&': {
              bg: 'white',
              borderColor: 'white',
              color: 'black',
            },
          },
        },
      };
    },
  },
  defaultProps: {},
};
